var app = angular.module("leonardo");

var VendorsStates = function($stateProvider) {
  $stateProvider.state('vendors', {
    url: '/vendors',
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: 'vendors.overview',
    ncyBreadcrumb: {
      label: 'Vendors'
    }
  });

  $stateProvider.state('vendors.overview', {
    url: "/overview",
    title: 'Vendors',
    only_filter_account: true,
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'VendorListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/vendor/list.html',
        controller: 'VendorList'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/vendor-list.html',
        controller: 'VendorListActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Overview'
    }
  });

  $stateProvider.state('vendors.categories', {
    url: "/categories",
    title: 'Vendor Categories',
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'VendorCategoryListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/vendor/category-list.html',
        controller: 'VendorCategoryList'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/vendor-category-list.html',
        controller: 'VendorListActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Categories'
    }
  });

  $stateProvider.state('vendors.add', {
    url: "/add",
    title: 'Add Vendor',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/vendor/form.html',
        controller: 'VendorForm'
      }
    },
    resolve: {
      vendorObj: ['VendorService', '$stateParams', function(VendorService, $stateParams) {
        return null;
      }]
    },
    ncyBreadcrumb: {
      label: 'Add Vendor'
    }
  });

  $stateProvider.state('vendors.edit', {
    url: "/:pk/edit",
    title: 'Edit Vendor',
    params: {
      pk: '',
      squash: false
    },
    cssClass: 'page-vendor-edit',
    action: 'edit',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/vendor/form.html',
        controller: 'VendorForm'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/vendor-list.html',
        controller: 'VendorListActions'
      }
    },
    resolve: {
      vendorObj: ['VendorService', '$stateParams', function(VendorService, $stateParams) {
        return VendorService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'Edit Vendor'
    }
  });
};

app.config(['$stateProvider', VendorsStates]);
